import type { CartPayment } from 'domains/cart';

/** Cart Payment and Braintree Payment details are similar but cased differently */
function formatCartPayment(payment: Required<CartPayment>) {
  return {
    lastFour: payment.last_four,
    postalCode: payment.postal_code,
    expirationMonth: payment.expiration_month,
    expirationYear: payment.expiration_year,
  };
}

function hasCardDetails(payment: CartPayment): payment is Required<CartPayment> {
  return !!payment.last_four && !!payment.expiration_month && !!payment.expiration_year;
}

export default {
  formatCartPayment,
  hasCardDetails,
};
